import Logo from "@/v2-status-client/components/Logo"

// Top brand strip on the page. Logo + wordmark on the left so the
// page roots itself in the Placepoint brand even when seen on a
// customer's monitor / projector; "Service Status" eyebrow on the
// right doubles as a page title for screen readers (the H1 is
// implicit in the URL `status.placepoint.no`).
function StatusPageHeader() {
  return (
    <header className="flex items-center justify-between gap-3">
      <a
        href="https://status.placepoint.no"
        className="flex items-center gap-2 text-[#6FFF90] hover:text-[#98ffaf]"
        aria-label="Placepoint Status"
      >
        <Logo width={18} height={24} aria-hidden />
        <span className="text-base font-semibold tracking-tight">
          Placepoint
        </span>
      </a>
      <div className="text-xs uppercase tracking-wider text-muted-foreground">
        Service Status
      </div>
    </header>
  )
}

export default StatusPageHeader
